<template>
  <div class="app-container">
    <el-card class="import-card">
      <div class="back-button-container">
        <el-button type="primary" icon="el-icon-arrow-left" @click="goBack" size="small">返回上一页</el-button>
      </div>
      <div class="hint-box">
        <div>注意：</div>
        <p>1. 请先下载模板，按模板格式填写数据后再导入。<br />
          2. 支持 .xlsx、.xls 格式，文件大小不超过 10MB。</p>
      </div>
      <div class="filter-container">
        <meeting-sign-up-import v-if="query.codes === 'IEForMeetSignUp'" @created="handleCreated" />
      </div>
      <div class="refresh">下载记录<el-button type="primary" @click="handleQuery" size="mini" icon="el-icon-refresh-right">刷新</el-button></div>
      <el-table v-loading="listLoading" :data="list" @sort-change="sortChange">
        <el-table-column label="文件名称" prop="title" align="center" />
        <el-table-column label="状态" prop="speed" align="center">
          <template slot-scope="{row}">
            <span v-if="row.state === 2">
              导入失败
              <el-tooltip v-if="row.errorLog" :content="row.errorLog" placement="top">
                <i class="el-icon-question" style="color: #f56c6c; margin-left: 5px; cursor: pointer;"></i>
              </el-tooltip>
            </span>
            <el-progress v-else :percentage="row.speed" :text-inside="true" :stroke-width="15"></el-progress>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createdTime" align="center" />
        <el-table-column label="导出人" prop="operatedName" align="center" />
        <el-table-column label="操作" prop="activityName" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleDownload(row)" v-if="row.speed === 100 && row.state === 1">下载</el-button>
            <el-button type="text" @click="showErrorLog(row)" v-else-if="row.state === 2">
              导入失败
              <el-tooltip v-if="row.errorLog" :content="row.errorLog" placement="top">
                <i class="el-icon-question" style="color: #f56c6c; margin-left: 5px; cursor: pointer;"></i>
              </el-tooltip>
            </el-button>
            <el-button type="text" v-else @click="handleDownload(row)">生成中</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import meetingSignUpImport from './meetingSignUp.vue'
import sysTaskApi from '@/api/sys/sysTask'

export default {
  components: {
    meetingSignUpImport
  },
  data() {
    return {
      query: {
        pageNo: 1,
        pageSize: 10
      },
      list: [],
      total: 0,
      listLoading: true
    }
  },
  created() {
    const { code } = this.$route.query
    this.query.codes = code || ''
    if (this.query.codes) {
      this.doQueryList({ pageNo: 1 })
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    handleCreated() {
      // 导入成功后的回调，刷新下载记录
      this.doQueryList({ pageNo: 1 })
    },
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }

      let params = JSON.parse(JSON.stringify(this.query))

      this.listLoading = true
      return sysTaskApi.fetchList(params)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleDownload(row) {
      if (!row.taskResponse) return
      let obj = JSON.parse(row.taskResponse)
      let {
        fileUrl,
        fileName
      } = obj
      fetch(fileUrl).then(_ => _.blob()).then(_ => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(_);
        console.log('fileName: ', fileName);
        link.setAttribute('download', fileName);
        link.click();
      })
    },
    showErrorLog(row) {
      if (row.errorLog) {
        this.$alert(row.errorLog, '导入失败原因', {
          confirmButtonText: '确定',
          type: 'error'
        })
      } else {
        this.$message.error('导入失败，暂无详细错误信息')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.import-card {
  position: relative;
}

.back-button-container {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
}

.hint-box {
  border: 1px solid #5dbde7;
  font-size: 14px;
  color: #6c6c6c;

  div {
    background: #5dbde7;
    border: 1px solid #1596cd;
    padding: 13px 23px;
    color: #fff;
  }

  p {
    padding: 0 18px;
    line-height: 22px;
  }
}

.filter-container {
  text-align: center;
  background: #eff8fd;
  margin-top: 30px;
  padding: 20px;

  .el-form-item {
    margin-bottom: 0;
  }
}

.refresh {
  font-size: 14px;
  background: #eff8fd;
  margin-top: 30px;
  border-bottom: 1px solid #ebeef5;
  padding: 10px 15px 10px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
